import { useEffect, useState } from "react"
import { editBotPackage } from "../../services/botPackagesApis"
import Table from "../Table"
import MyModal from "../MyModal"
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai"
import actionHelper from "../../lib/actionHelper"
import { toast } from "react-toastify"
import Input from "../Input"
import {
    createServerPackage,
    deleteServerPackage,
    editServerPackage,
    getServerPackageList,
} from "../../services/serverPackagesApis"
import { useAuth } from "../../lib/useAuth"

const cols = [
    {
        name: "اسم پکیج",
        colSpan: 1,
    },
    {
        name: "توضیحات",
        colSpan: 1,
    },
    {
        name: "اسلات ها",
        colSpan: 1,
    },
    {
        name: "تعداد روز",
        colSpan: 1,
    },
    {
        name: "قیمت به تومان",
        colSpan: 1,
    },
    {
        name: "",
        colSpan: 1,
    },
]

const ServerPackageEditModal = ({ user, packaage }) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleModal = () => setIsOpen(!isOpen)

    const submitHandler = (e) => {
        e.preventDefault()

        const form = new FormData(e.target)
        const packageDescription = form.get("description")
        const packageSlots = form.get("slots")
        const packageDays = form.get("days")
        const packageAmount = form.get("amount")
        let packageForAdmin = form.get("for-admin") == "on" ? true : false

        const data = {
            packageId: packaage.id,
            packageDescription,
            packageSlots,
            packageDays,
            packageAmount,
            packageForAdmin,
        }
        toast.promise(editServerPackage(data), {
            pending: "درحال ویرایش",
            success: "پکیج با موفقیت ویرایش شد",
        })
    }

    return (
        <>
            <button
                onClick={toggleModal}
                className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
            >
                <AiOutlineEdit size="1.7em" className=" hover:fill-yellow-400" />
            </button>
            <MyModal width="400px" height="400px" isOpen={isOpen} toggleModal={toggleModal}>
                <form className="mt-5" onSubmit={submitHandler}>
                    <div>
                        <Input
                            label="نام پکیج"
                            type="text"
                            name="package-name"
                            placeholder="نام پکیج"
                            required={true}
                            defaultValue={packaage.package_name}
                            disabled={true}
                        />
                        <span id="packageNameLabel">
                            <div class="show_info text-sm text-red-400">نامعتبر</div>
                        </span>
                    </div>
                    <div className="grid grid-cols-2 gap-5">
                        <div>
                            <Input
                                label="تعداد روز"
                                type="number"
                                name="days"
                                placeholder="تعداد روز"
                                defaultValue={packaage.package_days}
                            />
                        </div>
                        <div>
                            <Input
                                label="اسلات ها"
                                type="number"
                                name="slots"
                                placeholder="تعداد اسلات"
                                defaultValue={packaage.package_slots}
                                required={true}
                            />
                        </div>
                    </div>
                    <div>
                        <Input
                            label="مقدار به تومان"
                            type="number"
                            name="amount"
                            placeholder="مثال: 10000"
                            defaultValue={packaage.package_amount}
                            required={true}
                        />
                    </div>
                    <div>
                        <Input
                            label="توضیحات"
                            name="description"
                            placeholder="توضیحات"
                            defaultValue={packaage.package_description}
                            required={true}
                        />
                    </div>

                    <div class="flex items-start">
                        <div class="flex items-center h-5">
                            <input
                                id="foradmin"
                                aria-describedby="foradmin"
                                name="for-admin"
                                type="checkbox"
                                class="  focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded"
                                defaultChecked={packaage.package_for_admin}
                            />
                        </div>
                        <div class="text-sm ml-3">
                            <label for="foradmin" class="font-medium text-gray-300">
                                فقط برای ادمین
                            </label>
                        </div>
                    </div>
                    <button type="submit" className="mt-5 w-full styled-button success">
                        ساخت پکیج
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const CreateServerPackageModal = ({ packageList }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [packageNameIsValid, setPackageNameIsValid] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    const handlePackageNameOnChange = (event) => {
        var packageNameLabel = document.getElementById("packageNameLabel")
        var packageName = event.target.value
        const usedPackageName = packageList?.find((item) => item.package_name === packageName)
        if (usedPackageName || packageName == "") {
            setPackageNameIsValid(false)
            packageNameLabel.innerHTML = '<div class="show_info text-sm text-red-400">نامعتبر</div>'
        } else {
            setPackageNameIsValid(true)
            packageNameLabel.innerHTML = '<div class="show_info text-sm text-green-400">معتبر</div>'
        }
    }

    return (
        <>
            <button onClick={toggleModal} className="flex gap-2 w-32 pl-2 styled-button mr-3 mb-3">
                <img src="assets/icons/square-plus.svg" className="h-5 w-5" />
                ساخت پکیج
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="400px">
                <form
                    className="mt-5"
                    onSubmit={(e) => {
                        e.preventDefault()

                        toggleModal()
                        const form = new FormData(e.target)
                        const packageName = form.get("package-name")
                        const packageDescription = form.get("description")
                        const packageSlots = form.get("slots")
                        const packageDays = form.get("days")
                        const packageAmount = form.get("amount")
                        let packageForAdmin = form.get("for-admin") == "on" ? true : false

                        const data = {
                            packageName,
                            packageDescription,
                            packageSlots,
                            packageDays,
                            packageAmount,
                            packageForAdmin,
                        }

                        if (packageNameIsValid) {
                            toast.promise(createServerPackage(data), {
                                pending: "درحال ساخت پکیج",
                                success: "پکیج با موفقیت ساخته شد",
                            })
                        } else {
                            toast.error("نام کاربری درحال استفاده میباشد")
                        }
                    }}
                >
                    <div>
                        <Input
                            label="نام پکیج"
                            type="text"
                            name="package-name"
                            onChange={handlePackageNameOnChange}
                            placeholder="نام پکیج"
                            required={true}
                        />
                        <span id="packageNameLabel">
                            <div class="show_info text-sm text-red-400">نامعتبر</div>
                        </span>
                    </div>
                    <div className="grid grid-cols-2 gap-5">
                        <div>
                            <Input label="تعداد روز" type="number" name="days" placeholder="تعداد روز" />
                        </div>
                        <div>
                            <Input
                                label="اسلات ها"
                                type="number"
                                name="slots"
                                placeholder="تعداد اسلات"
                                required={true}
                            />
                        </div>
                    </div>
                    <div>
                        <Input
                            label="مقدار به تومان"
                            type="number"
                            name="amount"
                            placeholder="مثال: 10000"
                            required={true}
                        />
                    </div>
                    <div>
                        <Input label="توضیحات" name="description" placeholder="توضیحات" required={true} />
                    </div>

                    <div class="flex items-start mt-2">
                        <div class="flex items-center h-5">
                            <input
                                id="foradmin"
                                aria-describedby="foradmin"
                                name="for-admin"
                                type="checkbox"
                                class="  focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded"
                            />
                        </div>
                        <div class="text-sm ml-3">
                            <label for="foradmin" class="font-medium text-gray-300">
                                فقط برای ادمین
                            </label>
                        </div>
                    </div>
                    <button type="submit" className="mt-5 w-full styled-button success">
                        ساخت پکیج
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const ServerPackages = ({ user }) => {
    const [packageList, setPackageList] = useState(null)
    const updateUi = () => {
        if (user) {
            getServerPackageList()
                .then(({ data }) => {
                    console.log(data)
                    data = data?.map((p) => {
                        let obj = {
                            package_name: p.package_name,
                            package_description: p.package_description,
                            package_slots: p.package_slots,
                            package_days: p.package_days ? p.package_days : "دائمی",
                            package_amount: p.package_amount.toLocaleString("en-US"),
                            more: (
                                <div className="flex gap-3 justify-end">
                                    <ServerPackageEditModal packaage={p} />
                                    <button
                                        onClick={() => {
                                            toast.promise(deleteServerPackage(p.id), {
                                                pending: "درحال حذف",
                                                success: "حذف شد",
                                            })
                                        }}
                                        className="flex rounded-md m-2 select-none focus:outline-none focus:shadow-outline"
                                    >
                                        <AiOutlineDelete size="1.7em" className=" hover:fill-red-400" />
                                    </button>
                                </div>
                            ),
                        }
                        return obj
                    })
                    setPackageList(data)
                })
                .catch((err) => {
                    console.error(err)
                })
        }
    }

    useEffect(() => {
        updateUi()
        const interval = setInterval(updateUi, 5000)
        return () => clearInterval(interval)
    }, [])

    return (
        <>
            <CreateServerPackageModal packageList={packageList} />
            <Table cols={cols} rows={packageList} paging={{ maxRows: 10 }} />
        </>
    )
}

export default ServerPackages
